import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CongelamientoSaldosRoutingModule } from './congelamiento-saldos-routing.module';
import { CongelamientoSaldosHomeComponent } from './pages/congelamiento-saldos-home/congelamiento-saldos-home.component';
import { SharedModule } from '@shared/shared.module';
import { CongelamientoSaldosCuentasComponent } from './pages/congelamiento-saldos-cuentas/congelamiento-saldos-cuentas.component';
import { CongelamientoSaldosComponent } from './pages/congelamiento-saldos/congelamiento-saldos.component';
import { CongelamientoSaldosCuentasVoluntariasComponent } from './pages/congelamiento-saldos-cuentas-voluntarias/congelamiento-saldos-cuentas-voluntarias.component';
import { CongelamientoSaldosCuentasObligatoriasComponent } from './pages/congelamiento-saldos-cuentas-obligatorias/congelamiento-saldos-cuentas-obligatorias.component';
import { CongelamientoSaldosConfirmarComponent } from './pages/congelamiento-saldos-confirmar/congelamiento-saldos-confirmar.component';
import { CongelamientoSaldosTerminosYCondicionesModalComponent } from './components/congelamiento-saldos-terminos-y-condiciones-modal/congelamiento-saldos-terminos-y-condiciones-modal.component';
import { CongelamientoSaldosComprobanteComponent } from './pages/congelamiento-saldos-comprobante/congelamiento-saldos-comprobante.component';

@NgModule({
  imports: [
    CommonModule,
    CongelamientoSaldosRoutingModule,
    SharedModule,
  ],
  declarations: [
    CongelamientoSaldosHomeComponent,
    CongelamientoSaldosCuentasComponent,
    CongelamientoSaldosComponent,
    CongelamientoSaldosCuentasVoluntariasComponent,
    CongelamientoSaldosCuentasObligatoriasComponent,
    CongelamientoSaldosConfirmarComponent,
    CongelamientoSaldosTerminosYCondicionesModalComponent,
    CongelamientoSaldosComprobanteComponent,
  ],
  providers: [
    
  ]
})
export class CongelamientoSaldosModule {}
